import React from "react";
import ReactDOM from "react-dom";
import ReactGA from "react-ga4";
import { Ozon } from "./Ozon";

ReactGA.initialize([
    { trackingId: `${process.env.REACT_APP_GA}` },
    { trackingId: `${process.env.REACT_APP_ADS_TAG_ID}` },
]);

ReactDOM.render(<Ozon />, document.getElementById("root"));
